module.exports = __webpack_public_path__ + "img/security1.7f2286c1.svg";